import React, { useEffect, useState } from "react"
import { Header, Footer } from "shared-componentsMobile"
import { skin } from "config/api"
import DashboardBody from "../domains/Dashboard"
import { subscribeSocketUser, subscribeSocketSupport } from "config/socket.js"
import { AuthActions, MainActions } from "redux-store/models"
import { connect } from "react-redux"
import images from "themes/images"
import { notification } from "antd"
import { Captcha } from "shared-components"
import { dontShowRPCH } from "utils/HelperFunc"
import StaticDefaultHomePage from "routes/domains/StaticDefaultHomePage/StaticDefaultHomePage"
import OtpVerification from "../../routes/domains/Login/OtpVerification"

const Dashboard = (props) => {
  const [username, handleChangeUsername] = useState("")
  const [password, handleChangePassword] = useState("")
  const [activeCategory, setActiveCategory] = useState()
  const [activeService, setActiveService] = useState()
  const [prenotaBolletino, setPrenotaBolletino] = useState(false)
  const [captchaToken, setCaptchaToken] = useState(false)
  const [email, setEmail] = useState("")
  const [forgetPassword, setForgetPassword] = useState(false)
  const [showPassword, setShowPassword] = useState(false)
  const [activeTab, setActiveTab] = useState()
  const [showOtp, setShowOtp] = useState(false)
  const [otp, setOtp] = useState("")
  const [otpError, setOtpError] = useState("")
  const [otpLoading, setOtpLoading] = useState(false)

  const [credentials, setCredentials] = useState({
    username: "",
    password: "",
  })

  const loggedIn = props?.accountInfo?.profile?.role?.name

  const socketCall = (data) => {
    subscribeSocketUser(data.id, props)
    if (data.role.name === "support") {
      subscribeSocketSupport(props)
    }
  }
  console.log(props.loginMsg)

  const handleSubmit = (event) => {
    event.preventDefault()

    if (forgetPassword) {
      props.forgotPassword(email)
      return
    }

    if ((captchaToken && captchaToken !== "") || dontShowRPCH(forgetPassword)) {
      setCredentials({
        username,
        password,
      })

      if (props.setOtpInfo) {
        props.setOtpInfo(null)
      }

      props.signInByEmail(username, password, socketCall)

      if (props.loginMsg) {
        notification.error({
          message: props.loginMsg ?? "Error login",
          placement: "topRight",
        })
      }

      return
    }

    notification.error({
      message: "Verifica che non sei un robot (reCAPTCHA)",
      placement: "topRight",
    })
  }

  const handleVerifyOtp = (event) => {
    if (event) {
  event.preventDefault()
}

    if (otp.length !== 6) {
      setOtpError("Inserisci il codice OTP a 6 cifre.")
      return
    }

    if (!credentials.username || !credentials.password) {
      setOtpError("Credenziali mancanti.")
      return
    }

    if (props.setOtpInfo) {
      props.setOtpInfo(null)
    }

    setOtpError("")
    setOtpLoading(true)

    props.signInByEmail(
      credentials.username,
      credentials.password,
      socketCall,
      JSON.parse(localStorage.getItem("device_token")),
      otp,
    )
  }

  useEffect(() => {
    console.log(props.otpInfo)
    if (props.otpInfo && props.otpInfo.needs_2fa) {
      setShowOtp(true)
      setOtpLoading(false)

      setOtpError(props.otpInfo.message || "Il codice OTP inserito non è corretto.")

      return
    }

    if (props.accountInfo?.profile) {
      if (showOtp) {
        setShowOtp(false)
        setOtp("")
        setOtpError("")
        setOtpLoading(false)
      }
    }
  }, [props.otpInfo, props.accountInfo])

  useEffect(() => {
    const { scannedBarcode } = props
    if (!scannedBarcode) return
    if (scannedBarcode) {
      let parsedData
      try {
        parsedData = JSON.parse(scannedBarcode)

        if (parsedData && parsedData.service_id) {
          setActiveCategory(parsedData.category_id)

          setActiveService(parsedData.service_id)
          return
        }
      } catch (error) {
        console.error("Failed to parse JSON:", error)
      }
    }
  }, [props.scannedBarcode])

  return (
    <React.Fragment>
      {loggedIn ? (
        <React.Fragment>
          <div className="dashboardMobile">
            <Header
              togglePrenotazione={() => {
                setActiveCategory("SPRDPST")
                setActiveService("SBOL001")
              }}
              setActiveCategory={setActiveCategory}
              setActiveTab={setActiveTab}
            />
            <DashboardBody
              setActiveCategory={setActiveCategory}
              setActiveService={setActiveService}
              activeCategory={activeCategory}
              activeService={activeService}
              activeTab={activeTab}
            />
            <Footer />
          </div>
        </React.Fragment>
      ) : (
        <React.Fragment>
          <div className={`${prenotaBolletino ? "dashboardMobile" : ""}`}>
            {/* <Header togglePrenotazione={() => setPrenotaBolletino(true)} /> */}

            {prenotaBolletino ? (
              <DashboardBody
                setPrenotaBolletino={() => setPrenotaBolletino(false)}
                services={{
                  SPRDPST: {
                    group: "pagamenti",
                    name: "Pagamenti",
                    SBOLL: {
                      favourite: false,
                      name: "Bollettini Postali",
                      services: [
                        {
                          service_id: "SBOL001",
                          name: "Bollettini Bianchi",
                          cost: "0.00",
                          type: "B",
                          commissione: "2.00",
                          provigione: "0.50",
                          link: "",
                        },
                        {
                          service_id: "SBOL002",
                          name: "Bollettini Premarcati",
                          cost: "0.00",
                          type: "B",
                          commissione: "2.00",
                          provigione: "0.50",
                          link: "",
                        },
                      ],
                    },
                  },
                }}
                activeCategory="SPRDPST"
                activeService="SBOL001"
              />
            ) : (
              <div
                className="mrpaycard-bg"
                style={{
                  backgroundImage: `url(${images["mrpaycard-bg"]})`,
                  backgroundSize: "cover",
                  backgroundPosition: "right",
                  backgroundRepeat: "no-repeat",
                  width: "100%",
                  minHeight: "100vh",
                }}
              ></div>
              // <StaticDefaultHomePage />
            )}
            <Footer />
          </div>
        </React.Fragment>
      )}
      {window.location.hash.includes("login") && (
        <>
          <div className="loginPopUp animated slideInUp">
            {!showOtp ? (
              <>
                <div className="loginPopUp--header">Accedi</div>

                <div className="loginPopUp--subheader">con le tue credenziali</div>

                <form className="loginPopUp--forms" onSubmit={handleSubmit}>
                  {forgetPassword ? (
                    <PopupFormItem
                      label="Email"
                      value={email}
                      onChange={(e) => {
                        setEmail(e.target.value)
                      }}
                      handleSubmit={handleSubmit}
                    />
                  ) : (
                    <React.Fragment>
                      <PopupFormItem
                        label="UserName"
                        value={username}
                        onChange={(e) => {
                          handleChangeUsername(e.target.value)
                        }}
                        handleSubmit={handleSubmit}
                      />

                      <PopupFormItem
                        label="Password"
                        type={showPassword ? "text" : "password"}
                        value={password}
                        handleSubmit={handleSubmit}
                        onChange={(e) => {
                          handleChangePassword(e.target.value)
                        }}
                      />

                      {showPassword ? (
                        <i
                          className="fal fa-eye"
                          onClick={() => setShowPassword(!showPassword)}
                        />
                      ) : (
                        <i
                          className="fal fa-eye-slash"
                          onClick={() => setShowPassword(!showPassword)}
                        />
                      )}
                    </React.Fragment>
                  )}

                  <div className="loginPopUp--forms__item flex-row">
                    {!dontShowRPCH(forgetPassword) && (
                      <Captcha onChange={(token) => setCaptchaToken(token)} />
                    )}
                  </div>

                  <div className="loginPopUp--forms__item flex-row">
                    <button type="submit">
                      {!forgetPassword ? "Accedi" : "Vai"}
                    </button>

                    {skin.skin_id === 4 && (
                      <a href="https://services.planetservizi.it/login#/rut/y6flOjiiBH">
                        <span>REGISTRATI</span>
                      </a>
                    )}
                  </div>

                  <div className="loginPopUp--forms__item">
                    <span
                      className="forgotPassword"
                      onClick={() => setForgetPassword(!forgetPassword)}
                    >
                      {!forgetPassword ? "Password dimenticata?" : "Login"}
                    </span>
                  </div>
                </form>
              </>
            ) : (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  padding: "0 20px",
                }}
              >
                <div className="loginPopUp--header" style={{ marginBottom: 20 }}>
                  Autenticazione a due fattori
                </div>

                <OtpVerification
                  value={otp}
                  error={otpError}
                  loading={otpLoading}
                  onChange={(value) => {
                    setOtp(value)
                    setOtpError("")
                  }}
                  onVerify={handleVerifyOtp}
                  onBack={() => {
                    if (props.setOtpInfo) {
                      props.setOtpInfo(null)
                    }

                    setShowOtp(false)
                    setOtp("")
                    setOtpError("")
                    setOtpLoading(false)
                    setCredentials({
                      username: "",
                      password: "",
                    })
                  }}
                />
              </div>
            )}
          </div>

          <div
            className="backDrop"
            onClick={() => {
              setShowOtp(false)
              setOtp("")
              setOtpError("")
              setOtpLoading(false)
              setCredentials({
                username: "",
                password: "",
              })

              window.location.hash = "login"
            }}
          />
        </>
      )}
    </React.Fragment>
  )
}

const PopupFormItem = (props) => {
  const { label, type, handleSubmit, ...otherProps } = props

  const onKeyDown = (e) => {
    if (e.keyCode === 13) handleSubmit(e)
  }

  return (
    <div className="loginPopUp--forms__item">
      <div className="label">{label}</div>
      <input
        onKeyDown={onKeyDown}
        autoComplete="on"
        type={type || "text"}
        placeholder={label}
        name={label.toLowerCase()}
        id={label.toLowerCase() + "id"}
        {...otherProps}
      />
    </div>
  )
}

const mpstp = (state) => ({
  accountInfo: state.auth.accountInfo,
  scannedBarcode: state.auth.scannedBarcode,
  otpInfo: state.auth.otpInfo,
  loginMsg: state.auth.loginMsg,
})
export default connect(mpstp, { ...AuthActions, ...MainActions })(Dashboard)
